import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { SuggestionBlock } from './BlogitemsBig.styles';

type OptionProps = {
  openVideo?: () => void;
  readmore?: () => void;
  onSuggest?: () => void;
  onOpen?: () => void;
  showFullstoryBTN?: boolean;
  showSuggestionBtn?: boolean;
  showWatachBTtn?: boolean;
  img?: any;
  imgBoo?: boolean;
  media?: string;
  mediaBoo?: boolean;
  desc?: string;
  light?: boolean;
  bold?: boolean;
  heading?: boolean;
  title?: string;
  service?: string;
  author?: string;
  url?: string;
  urlTemp?: boolean;
  target?: string;
  mainHead?: boolean;
  byProp?: boolean;
  price?: boolean;
  priceVal?: string;
  serwidth?: string;
};

export const BlogItemsBigSingle = ({
  onSuggest,
  img,
  media,
  desc,
  light,
  bold,
  heading,
  title,
  service,
  author,
  imgBoo,
  mediaBoo,
  url,
  target,
  onOpen,
  urlTemp,
  mainHead,
  byProp,
  price,
  priceVal,
  serwidth
}: OptionProps) => {
  return (
    <>
      {urlTemp ? (
        <Link className="url" href={url} target={target}>
          <SuggestionBlock>
            {imgBoo && <Image src={img} width={686} height={408} alt="" />}
            {mediaBoo && (
              <video
                className="mediaVideo"
                controls={false}
                playsInline
                muted
                autoPlay
                loop
              >
                <source src={media} type="video/mp4" />
              </video>
            )}
            {bold && (
              <div className="Blk_D">
                <span>
                  <b>
                    <span dangerouslySetInnerHTML={{ __html: desc }} />
                  </b>
                </span>
              </div>
            )}
            {light && (
              <div className="Blk_D">
                <span dangerouslySetInnerHTML={{ __html: desc }} />
              </div>
            )}
            {heading && (
              <div className="Blk_D">
                <span className="top_line"
                  style={{ marginBottom: '7px', textAlign: 'center', width: serwidth }}
                  dangerouslySetInnerHTML={{ __html: service }}
                />

                {!mainHead ? (
                  <h3
                    className="mainHeading"
                    style={{ textTransform: 'none', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                ) : (
                  <h3
                    className="mainHeadingSmall"
                    style={{ textTransform: 'none', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                )}
                {price && (
                  <span
                    style={{ paddingTop: '10px', color: '#777' }}
                    dangerouslySetInnerHTML={{ __html: priceVal }}
                  />
                )}
                {/* {!byProp ? (
                  <span
                    style={{ fontSize: '14px', marginTop: '10px' }}
                    dangerouslySetInnerHTML={{ __html: `By: ${author}` }}
                  />
                ) : (
                  <span
                    style={{ fontSize: '14px', marginTop: '10px' }}
                    dangerouslySetInnerHTML={{ __html: author }}
                  />
                )} */}
              </div>
            )}
          </SuggestionBlock>
        </Link>
      ) : (
        <div className="url" onClick={onOpen} style={{ cursor: 'pointer' }}>
          <SuggestionBlock>
            {imgBoo && <Image src={img} width={686} height={408} alt="" />}
            {mediaBoo && (
              <video
                className="mediaVideo"
                controls={false}
                playsInline
                muted
                autoPlay
                loop
              >
                <source src={media} type="video/mp4" />
              </video>
            )}
            {bold && (
              <div className="Blk_D">
                <span>
                  <b>{desc}</b>
                </span>
              </div>
            )}
            {light && (
              <div className="Blk_D">
                <span dangerouslySetInnerHTML={{ __html: desc }} />
              </div>
            )}
          </SuggestionBlock>
        </div>
      )}
    </>
  );
};
